import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { NavigationService } from 'src/app/providers/navigation.service';

@Component({
  selector: 'sm-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {
  isEntityIndividual: any = sessionStorage.getItem('isEntityIndividual')
  entityHashId: string = ''
  loader: boolean = false
  constructor(private _navService: NavigationService, private loaderservice: LoaderServiceService, private router: Router,private route:ActivatedRoute) {
    this._navService.hideSidebarAndNav = false;
   }

  ngOnInit(): void {
    this.route.queryParams.subscribe(data => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash

      
    })
    this.loaderservice.showLoader = true
    this.loader = true
    setTimeout(() => {
      this.loaderservice.showLoader = false
      this.loader = false
    }, 100);

  }

  openSalesReport(){
    this.router.navigate(["/businesses", "details", "reports", "sales-report"], {
      queryParams: {
        entityHash: this.entityHashId,
      },
    });
  }
  openEmployeeSalesReport(){
    this.router.navigate(["/businesses", "details", "reports", "employee-sales-report"], {
      queryParams: {
        entityHash: this.entityHashId,
      },
    });
  }
  openExpenditureReport(){
    this.router.navigate(["/businesses", "details", "reports", "expenditure-report"], {
      queryParams: {
        entityHash: this.entityHashId,
      },
    });
  }
  openEmployeeSalaryReport(){
    this.router.navigate(["/businesses", "details", "reports", "employee-salary-report"], {
      queryParams: {
        entityHash: this.entityHashId,
      },
    });
  }
  openBookingsReport(){
    this.router.navigate(["/businesses", "details", "reports", "booking-report"], {
      queryParams: {
        entityHash: this.entityHashId,
      },
    });
  }
  openServiceReport(){
    this.router.navigate(["/businesses", "details", "reports", "service-report"], {
      queryParams: {
        entityHash: this.entityHashId,
      },
    });
  }
  openmembershipreport(){
    this.router.navigate(["/businesses", "details", "reports", "membership-report"], {
      queryParams: {
        entityHash: this.entityHashId,
      },
    });
  }
  openInvoiceReport(){
    this.router.navigate(["/businesses", "details", "reports", "invoice-report"], {
      queryParams: {
        entityHash: this.entityHashId,
      },
    });
  }
  openOnlinePaymentReport(){
    this.router.navigate(["/businesses", "details", "reports", "online-payments-report"], {
      queryParams: {
        entityHash: this.entityHashId,
      },
    });
  }
  openInventoryActivityReport(){
    this.router.navigate(["/businesses", "details", "reports", "inventory-activity-report"], {
      queryParams: {
        entityHash: this.entityHashId,
      },
    });
  }
  openPurchaseReport(){
    this.router.navigate(["/businesses", "details", "reports", "purchase-report"], {
      queryParams: {
        entityHash: this.entityHashId,
      },
    });
  }
  openProfitAnalysisReport(){
    this.router.navigate(["/businesses", "details", "reports", "profit-analysis-report"], {
      queryParams: {
        entityHash: this.entityHashId,
      },
    });
  }
  openTaxCollectionReport(){
    this.router.navigate(["/businesses", "details", "reports", "tax-collection-report"], {
      queryParams: {
        entityHash: this.entityHashId,
      },
    });
  }

}
